import { apiQBonoEnvironment } from 'src/environments/environment';

export const ApiQBonoEnv = {
  baseUrl: Object.prototype.hasOwnProperty.call(apiQBonoEnvironment, 'baseUrl')
    ? apiQBonoEnvironment.baseUrl
    : null,
};
